import Component from '@glimmer/component';

export default class PlayerNoteLinkComponent extends Component {}
